import { render, staticRenderFns } from "./widgets_best_bullish_values.vue?vue&type=template&id=353a887a&scoped=true&"
import script from "./widgets_best_bullish_values.vue?vue&type=script&lang=js&"
export * from "./widgets_best_bullish_values.vue?vue&type=script&lang=js&"
import style0 from "./widgets_best_bullish_values.vue?vue&type=style&index=0&id=353a887a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353a887a",
  null
  
)

export default component.exports